import get from 'lodash/get';

import {
  GET_ACCESS_CARDS_LIST_SUCCESS,
  GET_ACCESS_CARD_SUCCESS,
} from '../actionConstants';

const defaultState = {
  list: {},
  batch: {},
  card: {},
  isBatch: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_ACCESS_CARDS_LIST_SUCCESS:
      return {
        ...state,
        list: !action.isBatch ? action?.res?.data : state.list ?? {},
        batch: action.isBatch ? action?.res?.data : state.batch ?? {},
        isBatch: action.isBatch,
      };
    case GET_ACCESS_CARD_SUCCESS:
      return {
        ...state,
        card: get(action, 'res.data', {}),
        isBatch: action.isBatch,
      };
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    default:
      return state;
  }
};
